"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debug = exports.updateDijkstra_catFlee = exports.firePenalty = exports.unknownPenalty = exports.monsterPenalty = exports.windowPenalty = exports.doorPenalty = exports.wallPenalty = exports.dijkstra_max = void 0;
var entitiesUtils_sidecar_1 = require("../../../entities/entitiesUtils-sidecar");
var rogueMonofont_1 = require("../monofont/rogueMonofont");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueGlyphs_sidecar_1 = require("../targeting/rogueGlyphs-sidecar");
var rogueMaps_1 = require("./rogueMaps");
var rogueMaps_sidecar_1 = require("./rogueMaps-sidecar");
exports.dijkstra_max = 999;
exports.wallPenalty = 50;
exports.doorPenalty = 20;
exports.windowPenalty = 30;
exports.monsterPenalty = 30;
exports.unknownPenalty = 60;
exports.firePenalty = 30;
var updateDijkstra_catFlee = function () {
    var map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
    if (!map) {
        return;
    }
    var unvisited = [];
    // let visited: IMapSpace[] = []
    for (var i = 0; i < map.w; i++) {
        for (var j = 0; j < map.h; j++) {
            var t = rogueMaps_sidecar_1.rogueMaps.getTile(map, i, j);
            if (t) {
                t.dijkstra_isVisited = false;
                t.dijkstra_catFlee = exports.dijkstra_max;
                if (i === 1 || i === map.w - 2 || j === 1 || j === map.h - 1) {
                    if (rogueMaps_sidecar_1.rogueMaps.isOpenT(map, t)) {
                        t.dijkstra_catFlee = 0;
                    }
                }
                // console.log('i', i, 'j', j)
                // if (i === 1 && j === 1) {
                //   t.dijkstra_catFlee = 0
                // }
                unvisited.push(t);
            }
        }
    }
    var checkNeighbor = function (node, dx, dy) {
        var neighbor = rogueMaps_sidecar_1.rogueMaps.getTile(map, node.x + dx, node.y + dy);
        if (neighbor) {
            if (neighbor.dijkstra_isVisited) {
                return;
            }
            var penalty = 0;
            if (!rogueMaps_sidecar_1.rogueMaps.isPassibleT(neighbor)) {
                if (neighbor.eTile === rogueMaps_1.ETile.Door) {
                    penalty += exports.doorPenalty;
                }
                else if (neighbor.eTile === rogueMaps_1.ETile.Window) {
                    penalty += exports.windowPenalty;
                }
                else if (neighbor.eTile === rogueMaps_1.ETile.Wall) {
                    penalty += exports.wallPenalty;
                }
                else {
                    penalty += exports.unknownPenalty;
                }
            }
            var m = rogueMonsters_sidecar_1.rogueMonsters.getAt(neighbor.x, neighbor.y);
            if (m) {
                penalty += exports.monsterPenalty;
                return;
            }
            var nextValue = node.dijkstra_catFlee + 1 + penalty;
            if (neighbor.dijkstra_catFlee > nextValue) {
                neighbor.dijkstra_catFlee = nextValue;
            }
        }
    };
    //let firstNode = unvisited.find((t) => t.dijkstra_catFlee === 0)
    //assert.notNil(firstNode, 'cannot find first node')
    var checkNode = function (node) {
        checkNeighbor(node, 1, 0);
        checkNeighbor(node, -1, 0);
        checkNeighbor(node, 0, 1);
        checkNeighbor(node, 0, -1);
        node.dijkstra_isVisited = true;
        ///
    };
    // checkNode(firstNode)
    while (unvisited.length > 0) {
        unvisited.sort(function (a, b) { return -(b.dijkstra_catFlee - a.dijkstra_catFlee); });
        var node = unvisited.shift();
        if (node) {
            checkNode(node);
        }
    }
    // post process
    var addPenaltyNeighbor = function (m, dx, dy, penalty) {
        var neighbor = rogueMaps_sidecar_1.rogueMaps.getTile(map, m.x + dx, m.y + dy);
        if (neighbor) {
            if (neighbor.dijkstra_catFlee < exports.dijkstra_max) {
                neighbor.dijkstra_catFlee += penalty;
            }
        }
    };
    var ms = rogueMonsters_sidecar_1.rogueMonsters.getAll();
    ms.forEach(function (m) {
        if (m.data.isFire) {
            var penaltyScale = 1;
            if (m.data.type === 'f') {
                penaltyScale = 1 / 2;
            }
            var p = Math.floor(exports.firePenalty * penaltyScale);
            addPenaltyNeighbor(m, 1, 0, p);
            addPenaltyNeighbor(m, -1, 0, p);
            addPenaltyNeighbor(m, 0, 1, p);
            addPenaltyNeighbor(m, 0, -1, p);
            p = Math.floor((exports.firePenalty * penaltyScale * 1) / 2);
            addPenaltyNeighbor(m, 1, 1, p);
            addPenaltyNeighbor(m, -1, 1, p);
            addPenaltyNeighbor(m, 1, -1, p);
            addPenaltyNeighbor(m, -1, -1, p);
            // p = Math.floor((firePenalty * 1) / 3)
            // addPenaltyNeighbor(m, 2, 0, p)
            // addPenaltyNeighbor(m, -2, 0, p)
            // addPenaltyNeighbor(m, 0, 2, p)
            // addPenaltyNeighbor(m, 0, -2, p)
        }
    });
};
exports.updateDijkstra_catFlee = updateDijkstra_catFlee;
var debug = function () {
    (0, exports.updateDijkstra_catFlee)();
    var map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
    if (!map) {
        return;
    }
    for (var i = 0; i < map.w; i++) {
        for (var j = 0; j < map.h; j++) {
            var t = rogueMaps_sidecar_1.rogueMaps.getTile(map, i, j);
            if (t) {
                var glyph = '.';
                var glyph2 = '.';
                var color = rogueDef_sidecar_1.rogueDef.colors.light;
                if (t.dijkstra_catFlee <= 9) {
                    glyph = ' ';
                    glyph2 = '' + t.dijkstra_catFlee;
                }
                else if (t.dijkstra_catFlee <= 99) {
                    glyph = '' + Math.floor(t.dijkstra_catFlee / 10);
                    glyph2 = '' + (t.dijkstra_catFlee % 10);
                }
                else {
                    var num = t.dijkstra_catFlee - Math.floor(t.dijkstra_catFlee / 100) * 100;
                    color = rogueDef_sidecar_1.rogueDef.colors.red;
                    glyph = '' + Math.floor(num / 10);
                    glyph2 = '' + (num % 10);
                }
                // glyph = '' + t.dijkstra_catFlee
                color = entitiesUtils_sidecar_1.entitiesUtils.wrappedGet(rogueMonofont_1.rainbowScale, t.dijkstra_catFlee);
                if (t.dijkstra_catFlee === exports.dijkstra_max) {
                    glyph = 'X';
                    glyph2 = 'X';
                    color = rogueDef_sidecar_1.rogueDef.colors.red;
                }
                rogueGlyphs_sidecar_1.rogueGlyphs.write(i - 0.25, j, glyph, color, 2, 0.5);
                rogueGlyphs_sidecar_1.rogueGlyphs.write(i + 0.25, j, glyph2, color, 2, 0.5);
            }
        }
    }
};
exports.debug = debug;
